import VipBanner from './VipBanner';
export default VipBanner;
//# sourceMappingURL=index.js.map